'use strict';
import angular from 'angular';

angular.module('ioServiceConnections.services', [])

    .factory('ioServiceConnectionsService', ['IORestangular', '$q', function (IORestangular, $q) {
        var pushServices = IORestangular.all('serviceConnections/pushServices');
        var serviceConnections = IORestangular.all('serviceConnections');
        var serviceConnection = IORestangular.all('serviceConnections/serviceConnection');
        var clusterServiceConnections = IORestangular.all('clusterServiceConnections');
        var connectionsForClusterAndService = IORestangular.all('clusterServiceConnections/connectionsForClusterAndService');
        var clusterServiceConnectionGet = IORestangular.all('clusterServiceConnection/getDefault');
        var clusterServiceConnection = IORestangular.all('clusterServiceConnections/clusterServiceConnection');
        var clusterServiceConnectionSet = IORestangular.all('clusterServiceConnections/setDefault');
        var connectionsForService = IORestangular.all('serviceConnections/connectionsForService');

        var getPushServices = function () {
            return pushServices.customGET(undefined, undefined, undefined, undefined);
        };

        var getServiceConnections = function () {
            return serviceConnections.customGET(undefined, undefined, undefined, undefined);
        };

        var getServiceConnection = function (serviceId) {
            return serviceConnection.customGET(undefined, {id: serviceId}, undefined, undefined);
        };

        var addServiceConnection = function (serviceObj) {
            return serviceConnection.customPOST(serviceObj, undefined, undefined, undefined);
        };

        var updateServiceConnection = function (serviceObj) {
            return serviceConnection.customPUT(undefined, undefined, serviceObj, undefined);
        };

        var deleteServiceConnection = function (serviceObj) {
            return serviceConnection.remove(serviceObj);
        };

        var getClusterServiceConnections = function () {
            return clusterServiceConnections.customGET(undefined, undefined, undefined, undefined);
        };

        var getConnectionsForClusterAndService = function (paramObj) {
            return connectionsForClusterAndService.customGET(undefined, paramObj, undefined, undefined);
        };

        var getDefaultClusterServiceConnection = function (paramObj) {
            return clusterServiceConnectionGet.customGET(undefined, undefined, paramObj, undefined);
        };

        var setDefaultClusterServiceConnection = function (paramObj) {
            return clusterServiceConnectionSet.customPUT(undefined, undefined, paramObj, undefined);
        };

        var addClusterServiceConnection = function (serviceObj) {
            return clusterServiceConnection.customPOST(serviceObj, undefined, undefined, undefined);
        };

        var updateClusterServiceConnection = function (serviceObj) {
            return clusterServiceConnection.customPUT(undefined, undefined, serviceObj, undefined);
        };

        var getConnectionsForService = function (serviceId) {
            return connectionsForService.customGET(undefined, {serviceId: serviceId}, undefined, undefined);
        };

        return {
            getPushServices: getPushServices,
            getServiceConnections: getServiceConnections,
            getServiceConnection: getServiceConnection,
            addServiceConnection: addServiceConnection,
            updateServiceConnection: updateServiceConnection,
            deleteServiceConnection: deleteServiceConnection,
            getClusterServiceConnections: getClusterServiceConnections,
            getConnectionsForClusterAndService: getConnectionsForClusterAndService,
            getDefaultClusterServiceConnection: getDefaultClusterServiceConnection,
            setDefaultClusterServiceConnection: setDefaultClusterServiceConnection,
            addClusterServiceConnection: addClusterServiceConnection,
            updateClusterServiceConnection: updateClusterServiceConnection,
            getConnectionsForService: getConnectionsForService
        };
    }]);